import React from 'react'
import styled from 'styled-components'
import Grid from '@material-ui/core/Grid'
import ContentLoader from 'react-content-loader'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const LoaderStyle = styled(Grid)`
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`
const CouponCircle = styled.div`
  &::before {
    content: ' ';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.color.blue20};
    position: absolute;
    left: 40%;
    top: -4px;
    z-index: 2;
  }
  &::after {
    content: ' ';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.color.blue20};
    position: absolute;
    left: 40%;
    bottom: -4px;
    z-index: 2;
  }
`

export const DesktopListLoader = (props) => {
  const { stack = 3 } = props
  return (
    <Grid container spacing={2}>
      {Array.from({ length: stack }, (v, k) => k + 1).map((uniqKey) => (
        <Grid item sm={6} md={4} lg={4} key={uniqKey}>
          <LoaderStyle>
            <ContentLoader
              speed={2}
              width={364}
              height={313}
              viewBox="0 0 364 313"
              backgroundColor="#ecf0f3"
              foregroundColor="#f1f6fb"
            >
              <rect x="0" y="0" width="364" height="204" />
              <rect x="16" y="220" rx="4" ry="4" width="294" height="24" />
              <rect x="16" y="260" rx="4" ry="4" width="168" height="24" />
            </ContentLoader>
          </LoaderStyle>
        </Grid>
      ))}
    </Grid>
  )
}

export const MobileListLoader = (props) => {
  const { stack = 3 } = props
  return (
    <Grid container spacing={2}>
      {Array.from({ length: stack }, (v, k) => k + 1).map((uniqKey) => (
        <Grid item sm={6} xs={12} key={uniqKey}>
          <LoaderStyle>
            <CouponCircle />
            <ContentLoader
              speed={2}
              width={352}
              height={105}
              viewBox="0 0 352 105"
              backgroundColor="#ecf0f3"
              foregroundColor="#f1f6fb"
            >
              <rect x="0" y="0" rx="4" ry="4" width="140" height="105" />
              <rect x="156" y="26" rx="4" ry="4" width="179" height="20" />
              <rect x="156" y="58" rx="4" ry="4" width="90" height="20" />
            </ContentLoader>
          </LoaderStyle>
        </Grid>
      ))}
    </Grid>
  )
}

export const ListLoader = (props) => {
  const { stack = 3 } = props
  const theme = useTheme()
  const matchesSm = useMediaQuery(theme.breakpoints.down('xs'))
  if (matchesSm) {
    return <MobileListLoader stack={stack} />
  }
  return <DesktopListLoader stack={stack} />
}

export const CategoryLoader = () => (
  <ContentLoader
    height={32}
    width={64}
    speed={2}
    backgroundColor="#d5e1ff"
    foregroundColor="#ecf0f3"
  >
    <rect x="0" y="0" rx="16" ry="16" width="64" height="32" />
  </ContentLoader>
)

export const LoginLoader = () => (
  <ContentLoader
    height={32}
    width={72}
    speed={2}
    backgroundColor="#d5e1ff"
    foregroundColor="#ecf0f3"
  >
    <rect x="38" y="9" rx="3" ry="3" width="32" height="14" />
    <circle cx="16" cy="16" r="16" />
  </ContentLoader>
)
